// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderItemGroup_container__2x_Km","heading":"OrderItemGroup_heading__2SZOr","items":"OrderItemGroup_items__1BGg3"};